// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#BreadcrumbList-module-breadcrumbList {
  display: none;
}

@media screen and (min-width: 400px) {

  #BreadcrumbList-module-breadcrumbList {
    height: 42px;
    padding: 0;
    display: flex;
  }

  #BreadcrumbList-module-breadcrumbList > ul {
    display: flex;
    gap: 15px;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;
    overflow-x: auto;
    flex-direction: row;
  }

  #BreadcrumbList-module-breadcrumbList > ul > li:first-of-type {
    margin-left: 15px;
  }

  #BreadcrumbList-module-breadcrumbList > ul > li:last-of-type {
    margin-right: 15px;
  }

  #BreadcrumbList-module-breadcrumbList > ul > li {
    flex-shrink: 0;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/BreadcrumbList/BreadcrumbList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,YAAY;IACZ,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAEF","sourcesContent":["#breadcrumbList {\r\n  display: none;\r\n}\r\n\r\n@media screen and (min-width: 400px) {\r\n\r\n  #breadcrumbList {\r\n    height: 42px;\r\n    padding: 0;\r\n    display: flex;\r\n  }\r\n\r\n  #breadcrumbList > ul {\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: center;\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    overflow-x: auto;\r\n    flex-direction: row;\r\n  }\r\n\r\n  #breadcrumbList > ul > li:first-of-type {\r\n    margin-left: 15px;\r\n  }\r\n\r\n  #breadcrumbList > ul > li:last-of-type {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  #breadcrumbList > ul > li {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var breadcrumbList = `BreadcrumbList-module-breadcrumbList`;
export default ___CSS_LOADER_EXPORT___;
